import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import STLRealEstateDetailedBill from './STLRealEstateDetailedBill';

class STLRealEstateDetailedBillModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { bill, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              St. Louis Real Estate Bill Id:
              {` ${bill.id}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <STLRealEstateDetailedBill bill={bill} isModal />;
              }
              return undefined;
            })()}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

STLRealEstateDetailedBillModal.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default STLRealEstateDetailedBillModal;
